import { TIPO_DOC_ENUM } from "./common.constants";

const MAESTRO_TIPO_DOC =[
    {label: 'NIE', value: TIPO_DOC_ENUM.NIE},
    {label: 'NIF', value: TIPO_DOC_ENUM.NIF},
    {label: 'Pasaporte', value: TIPO_DOC_ENUM.PASSPORT},
]

export default MAESTRO_TIPO_DOC;